<template>
  <div class="auth-page">
    <div class="content-top">
      <div class="content-top-left active-border-color">
        <div class="title">可选权限组</div>
        <div style="width: 100%; padding: 10px">
          <el-input
            placeholder="请输入权限组名称"
            v-model="account"
            clearable
            class="input-with-select"
          >
          </el-input>
        </div>

        <div class="content-main">
          <el-scrollbar class="scroll-bar">
            <el-tree
              class="tree-list"
              ref="tree"
              node-key="code"
              :data="treeData"
              :props="props"
              :renderContent="renderContent"
              :filter-node-method="filterNode"
              show-checkbox
            >
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="content-top-middle">
        <div style="text-align: center; margin-bottom: 30px">
          <img
            src="../../../common/assets/images/arrows_left.png"
            @click="transferPerson('right')"
            style="cursor: pointer"
            alt=""
          />
        </div>
        <div style="text-align: center">
          <img
            src="../../../common/assets/images/arrows_right.png"
            @click="transferPerson('left')"
            alt=""
            style="cursor: pointer"
          />
        </div>
      </div>
      <div class="content-top-right active-border-color">
        <div class="title">已选设备权限组</div>
        <div style="width: 100%; padding: 10px">
          <el-input
            placeholder="请输入权限组名称"
            v-model="accountRight"
            clearable
            class="input-with-select"
          >
          </el-input>
        </div>
        <div class="content-main">
          <el-scrollbar class="scroll-bar">
            <ul class="person-list">
              <li
                v-for="(item, index) in accountRight
                  ? selectedListFilter
                  : selectedList"
                :key="index"
                class="person"
              >
                <el-checkbox v-model="item.checked"></el-checkbox>
                <span class="checked-name" :title="item.name">{{
                  item.name
                }}</span>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  watch: {
    account(val) {
      this.$refs.tree.filter(val);
    },
    accountRight(val) {
      if (val) {
        this.selectedListFilter = this.selectedList.filter((el) => {
          return el.name.indexOf(val) != -1;
        });
      } else {
        this.selectedListFilter = [];
      }
    },
  },
  components: {},
  data() {
    return {
      showPanel: false,
      props: {
        label: "name",
        // children: "children",
        id: "code",
        isLeaf: "isLeaf",
      },
      treeData: [],
      selectedList: [],
      selectedListFilter: [],
      //判断是否已经开始懒加载
      isLoadNode: false,
      account: "",
      accountRight: "",
      SecurityWorkGroupId: "",
    };
  },
  methods: {
    open(id) {
      this.selectedListFilter.length = 0;
      this.selectedList.length = 0;
      this.account = "";
      this.accountRight = "";
      this.SecurityWorkGroupId = id;
      // this.showPanel = true;
      this.getRlatAccountGroup();
      this.getInList();
    },
    // 获取当前账户未绑定的设备权限组列表(可选)
    getRlatAccountGroup() {
      this.treeData = [];
      let params = {
        inOutType: 2,
        securityWorkGroupCode: this.SecurityWorkGroupId,
      };
      this.$fetch(api.querySecurityWorkGroupAuthGroupList, params).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.treeData = res.returnObj.map((item) => {
              return {
                code: item.authGroupCode,
                name: item.authGroupName,
                checked: false,
              };
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取当前账户已绑定的设备权限组
    getInList() {
      let params = {
         inOutType: 1,
        securityWorkGroupCode: this.SecurityWorkGroupId,
      };
      this.$fetch(api.querySecurityWorkGroupAuthGroupList, params).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.selectedList = res.returnObj.map((item) => {
              return {
                code: item.authGroupCode,
                name: item.authGroupName,
                checked: true,
              };
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
        console.log("this.selectedList", this.selectedList);
      });
    },
    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>
      );
    },
    // 数组扁平化
    flattenArr(arr) {
      const self = this;
      return arr.reduce((flat, toFlatten) => {
        return flat.concat(
          Array.isArray(toFlatten) ? self.flattenArr(toFlatten) : toFlatten
        );
      }, []);
    },
    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        console.log("--left---------");
        // 获取左边未选中的人员 (左侧列表勾选的)
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        // console.log('选中的节点', selectedPerson, this.selectedList)
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          let data = this.selectedList.map((item) => {
            return {
              code: item.code,
              name: item.name,
              checked: true,
            };
          });
          selectedPerson = selectedPerson.map((item) => {
            return {
              code: item.code,
              name: item.name,
              checked: true,
            };
          });
          // 人员根据账号去重
          this.selectedList = this.reduceArr(data, "code");
          // console.log(this.selectedList, '去重人员')

          // 当勾选中后改变左侧树checked的属性值
          this.treeData.forEach((item, index) => {
            selectedPerson.forEach((items) => {
              if (items.code === item.code) {
                item.checked = items.checked;
              }
            });
          });

          // let leftChoose = this.treeData.filter(item => item.checked === true)
          // console.log('----leftChoose---leftChoose', leftChoose);
          // this.treeData.forEach((item, index) => {
          //   if (item.checked) {
          //     this.treeData.splice(index, leftChoose.length)
          //   }
          // })

          this.treeData = this.treeData.filter(
            (item) => item.checked === false
          );
          // console.log('----leftNoChoose---leftNoChoose', leftNoChoose);
        } else {
          selectedPerson = this.$refs.tree.getCheckedNodes(true);
          // this.selectedList = [];
        }
      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(
            (item) => item.checked === true
          );
          this.selectedList = this.selectedList.filter(
            (item) => item.checked === false
          );
          this.treeData = this.treeData.concat(rightChoose);
          this.treeData = this.reduceArr(this.treeData, "code");
        } else {
          this.selectedList = [];
        }
        // console.log(this.treeData, '右 this.treeData已选人员')
      }
    },
    // 根据key对数组对象去重
    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit() {
      // console.log('====保存的列表----', this.selectedList);
      // console.log('====左侧的列表----', this.treeData);
      let chooseIds = [];
      if (this.selectedList.length) {
        this.selectedList
          .filter((item) => item.checked === true)
          .forEach((item) => {
            chooseIds.push(item.code);
          });
      }
      let params = {
        authGroupCodeList: chooseIds,
        SecurityWorkGroupId: this.SecurityWorkGroupId,
      };
      this.$fetch(api.group.updateAccountAuthGroup, params).then((res) => {
        if (res.success) {
          this.$message.success("配置设备权限组成功");
          this.close();
          this.$emit("refreshData");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    close() {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = "";
    },
    // 懒加载节点
    loadNode(node, resolve) {
      if (node.data && node.data.code) {
        let accountGroupCode = node.data.code;
        // 获取当前账户组关联的人员
        this.$fetch(api.reserve.queryAccountGroup, { accountGroupCode }).then(
          (res) => {
            if (res.success) {
              if (res.returnObj && res.returnObj.length) {
                let childrenData = res.returnObj.map((item) => {
                  return {
                    code: item.authGroupCode,
                    name: `${item.authGroupName}(${item.authGroupCode})`,
                    isLeaf: true,
                  };
                });
                this.$set(node.data, "children", childrenData);
                resolve(childrenData);
                // this.childrenDataList = childrenData;
              } else {
                return resolve([]);
              }
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.auth-page {
  padding: 24px;
  height: 100%;
  .content {
    &-top {
      height: 100%;
      display: flex;
      align-content: space-around;
      &-left,
      &-right {
        overflow: hidden;
        // width: 300px;
        width: 100%;
        // height: 350px;
        // border-width: 1px;
        // border-style: solid;
        @include set_theme_color(background-color, main-content-bg-color);

        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          //   height: calc(100% - 90px);
          //   overflow-y: scroll;
          overflow: hidden;
        }
        .person-list {
          text-align: left;
          padding: 10px 20px;
          height: calc(100% - 36px);
          // overflow-y: scroll;
          .person {
            padding: 5px 0px;
            color: #b9c3d9;
            font-size: 14px;
            display: flex;
            .name-icon {
              margin: 0 5px;
            }
            .checked-name {
              margin-left: 10px;
              display: inline-block;
              max-width: 210px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &-middle {
        margin: 0 20px;
        width: 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
      }
    }
  }
  .content-main {
    height: calc(100% - 85px);
    // padding: 10px 6px;
    // background: #0d121c;
  }
  .scroll-bar {
    height: calc(100% - 10px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px;
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
  }
  .title {
    height: 35px;
    color: #fff;
    font-size: 14px;
    line-height: 35px;
    text-align: center;
    font-weight: normal;
    background: #0d121c;
  }
  .tree-list .personwidth {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #b9c3d9;
  }
  .tree-list .el-tree .is-current > .el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }
  .person-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  //   .expand {
  //     display: inline-block;
  //     width: 12px;
  //     height: 12px;
  //     margin-right: 2px;
  //     border: 1px solid #b3cbf1;
  //   }
}
</style>